import React from 'react'
import { Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Select } from 'src/components'
import Commentary from 'src/components/inputs/Commentary/Commentary'
import { selectFelItemTypes } from 'src/selectors/company.selector'
import { getUniversalItem } from 'src/utils/getUniversalItem'

interface Props {
  item: IItemSelectTable
  updateValues: () => void
  show: boolean
  onHide: () => void
  commentaryLabel?: string
  param?: string
  disabled?: boolean
}
export const ItemCommentary = ({
  item,
  updateValues,
  show,
  onHide,
  commentaryLabel,
  param = 'commentary',
  disabled = false,
}: Props) => {
  const felItemTypes = useSelector(selectFelItemTypes)

  const felItemType = felItemTypes?.find(({ value }) => value === item.felItemTypeId)

  return (
    <>
      {/* @ts-expect-error Error por tipado JS*/}
      <Commentary
        disabled={!felItemType && item.id === 1}
        value={item[param]}
        currentValue={item[param]}
        show={show}
        onChange={value => {
          if (value && item.line.length === 0) {
            const unix = getUniversalItem()
            item.line = unix.line
          }
          item[param] = value
          updateValues()
        }}
        onHide={() => {
          if (!item[param] || item[param] === null) item.line = []
          onHide()
        }}
        textCommentary={item.label}
        edit={!disabled}
        max={item.id === 1 ? 100 : 1000}
        label={(item.id === 1 && 'Nombre del producto') || commentaryLabel}
        commentaryLabel={(item.id === 1 && 'Nombre del producto') || commentaryLabel}
        prepend={
          item.id === 1 && (
            <Col xl={12}>
              <Select
                label={'Bien o Servicio'}
                info={
                  'La propiedad "Bien o Servicio" se usará para la factura electrónica'
                }
                required
                value={felItemType}
                options={felItemTypes}
                onChange={felItemType => {
                  item.felItemTypeId = felItemType.value
                  updateValues()
                }}
              />
            </Col>
          )
        }
        textarea={item.id !== 1}
        isRequired
      />
    </>
  )
}
